import ChatAvatar from '../atoms/chatAvatar'

const ActiveMembers = ({ members }) => {
  return (
    <div>
      <p className="text-lg font-medium text-primary mb-4">
        Online members <span className="font-normal text-primary/50">({members.length})</span>
      </p>
      {members.map(( member , i) => (
        <div key={i + member.username} className="my-3">
          <ChatAvatar avatar = {member.avatar} username={member.username} />
        </div>
      ))}
    </div>
  )
}

export default ActiveMembers
